/**
 * Modifier for config. Converts "env to config" friendly domain
 * config format to actual domain config format.
 *
 * @param config
 */
export function modifier(config) {
  if (typeof config.domain === 'object') {
    (typeof config.domains !== 'object') && (config.domains = {});
    for (const key of Object.keys(config.domain)) {
      const domainCfg = config.domain[key];
      (typeof domainCfg.domain === 'string') && (config.domains[domainCfg.domain] = domainCfg);
    }
  }

  /**
   * Merge custom variable scope mappings configured via env into the existing editor mappings.
   *
   * Source path (from env -> config):
   *   questionnaire.editor.variables.scopes.custom.mappings[<SCOPE_NAME>][<i>].{name,value}
   * Example envs:
   *   NGMEDAX_QUESTIONNAIRE_EDITOR_VARIABLES_SCOPES_CUSTOM_MAPPINGS_GDT_1_NAME
   *   NGMEDAX_QUESTIONNAIRE_EDITOR_VARIABLES_SCOPES_CUSTOM_MAPPINGS_GDT_1_VALUE
   *
   * Target path (existing runtime config used by the app):
   *   'questionnaire-editor'.variable.scopes[<SCOPE_NAME>].mappings
   */
  const srcMappingsRoot =
    (config?.questionnaire?.editor?.variables?.scopes?.custom?.mappings &&
      typeof config.questionnaire.editor.variables.scopes.custom.mappings === 'object')
      ? config.questionnaire.editor.variables.scopes.custom.mappings
      : null;

  const targetMappingsRoot =
    (typeof config['questionnaire-editor']?.variable?.scopes === 'object')
      ? config['questionnaire-editor'].variable.scopes
      : null;

  if (!srcMappingsRoot || !targetMappingsRoot) {
    return;
  }

  for (const scopeName of Object.keys(srcMappingsRoot)) {
    const mappingsToMerge = {};
    const items = srcMappingsRoot[scopeName];
    if (!items || typeof items !== 'object') {
      continue;
    }

    (typeof targetMappingsRoot[scopeName] !== 'object') && (targetMappingsRoot[scopeName] = {});
    const scopeCfg = targetMappingsRoot[scopeName];
    (typeof scopeCfg.mappings !== 'object') && (scopeCfg.mappings = {});

    for (const idx of Object.keys(items)) {
      const entry = items[idx];
      if (!entry || typeof entry !== 'object') {
        continue;
      }

      const name = entry.name;
      const value = entry.value;

      if (typeof name !== 'string' || (typeof value !== 'string' && typeof value !== 'number')) {
        continue;
      }

      mappingsToMerge[name] = value + '';
    }

    scopeCfg.mappings = Object.assign({}, scopeCfg.mappings || {}, mappingsToMerge);
  }
}
